import React, { memo } from 'react'

import { func, string } from 'prop-types'

import CardFooter from 'Pods/Shared/Waitlist/CardFooter/CardFooter'
import SubscriptionBullets from 'Pods/Shared/Waitlist/SubscriptionBullets/SubscriptionBullets'
import { useSubscriptionHref } from 'Pods/ThreeDStudio/Hooks/useSubscriptionHref'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import { TODO_LEARN_MORE_HREF } from '../../constants'

function SubscriptionCard({ ctaLabel = 'Get Subscription', onClose: handleClose }) {
  const subscriptionPrice = useThreeDStudioStore(state => state.subscription.subscriptionPrice)
  const subscriptionOriginalPrice = useThreeDStudioStore(
    state => state.subscription.subscriptionOriginalPrice
  )
  const subscriptionMonthlyModels = useThreeDStudioStore(
    state => state.subscription.subscriptionMonthlyModels
  )
  const subscriptionHref = useSubscriptionHref()

  return (
    <section className="usage-modal__card usage-modal__card--subscription">
      <div className="usage-modal__card-chip cgt-caption-semibold usage-modal__card-chip--subscription">
        CGTrader Subscription
      </div>

      {subscriptionPrice && (
        <div className="usage-modal__price">
          {subscriptionOriginalPrice && (
            <span className="usage-modal__price-original cgt-body-lg-semibold">
              {subscriptionOriginalPrice}
            </span>
          )}
          <span className="cgt-heading-300">{subscriptionPrice}</span>
          <span className="usage-modal__price-unit cgt-caption-semibold">/ month</span>
        </div>
      )}

      <SubscriptionBullets variant="subscription" monthlyModels={subscriptionMonthlyModels} />

      <CardFooter
        variant="subscription"
        ctaLabel={ctaLabel}
        subscriptionHref={subscriptionHref}
        learnMoreHref={TODO_LEARN_MORE_HREF}
        onClose={handleClose}
      />
    </section>
  )
}

SubscriptionCard.propTypes = {
  ctaLabel: string,
  onClose: func.isRequired,
}

export default memo(SubscriptionCard)
